import React from 'react';
import ExportDropdown from './ExportDropdown';
import ActionDropdown from './ActionDropdown';

interface OtherAction {
  image?: string;
  text?: string;
  action?: () => void;
  style?: React.CSSProperties;
  isDropdown?: boolean;
  dropdownOptions?: { value: string; label: string }[];
  currentValue?: string;
  onSelect?: (value: string) => void;
}

interface ChartHeadProps {
  title: string;
  isDialogOpen: boolean;
  onToggleDialog: () => void;
  isExporting: boolean;
  showExportDropdown: boolean;
  onToggleExportDropdown: () => void;
  onPdfExport: () => void;
  onCsvExport: () => void;
  onXlsExport?: () => void;
  showXlsExport?: boolean;
  otherActions?: OtherAction[];
  openDropdownIndex: number | null;
  onDropdownToggle: (index: number) => void;
  dropdownSelections: { [key: number]: Set<string> };
  setDropdownSelections: React.Dispatch<React.SetStateAction<{ [key: number]: Set<string> }>>;
  initialDropdownSelections: { [key: number]: Set<string> };
  setInitialDropdownSelections: React.Dispatch<React.SetStateAction<{ [key: number]: Set<string> }>>;
  lastCurrentValueRef: React.MutableRefObject<{ [key: number]: string | undefined }>;
  dropdownRefs: React.MutableRefObject<{ [key: number]: HTMLDivElement | null }>;
  exportDropdownRef: React.RefObject<HTMLDivElement>;
}

const ChartHead: React.FC<ChartHeadProps> = ({
  title,
  isDialogOpen,
  onToggleDialog,
  isExporting,
  showExportDropdown,
  onToggleExportDropdown,
  onPdfExport,
  onCsvExport,
  onXlsExport,
  showXlsExport = false,
  otherActions = [],
  openDropdownIndex,
  onDropdownToggle,
  dropdownSelections,
  setDropdownSelections,
  initialDropdownSelections,
  setInitialDropdownSelections,
  lastCurrentValueRef,
  dropdownRefs,
  exportDropdownRef,
}) => {
  return (
    <div className='chart-head'>
      <h3 className='chart-title'>{title}</h3>
      <div className='chart-buttons'>
        <button
          className="expend-button"
          about="tools"
          onClick={onToggleDialog}
          style={{
            backgroundImage: `url('${__dirname}${isDialogOpen ? "close" : "expand"}.png')`,
            backgroundSize: '13px',
          }}
        />
        <div className="other-actions">
          <ExportDropdown
            isExporting={isExporting}
            showExportDropdown={showExportDropdown}
            onToggle={onToggleExportDropdown}
            onPdfExport={onPdfExport}
            onCsvExport={onCsvExport}
            onXlsExport={onXlsExport}
            showXlsExport={showXlsExport}
            exportDropdownRef={exportDropdownRef}
          />
          {otherActions && otherActions.length > 0 ? (
            <>
              {otherActions.map((action, idx) => {
                if (action.isDropdown && action.dropdownOptions) {
                  return (
                    <ActionDropdown
                      key={idx}
                      index={idx}
                      isDropdown={action.isDropdown}
                      dropdownOptions={action.dropdownOptions}
                      currentValue={action.currentValue}
                      onSelect={action.onSelect}
                      style={action.style}
                      openDropdownIndex={openDropdownIndex}
                      onDropdownToggle={onDropdownToggle}
                      dropdownSelections={dropdownSelections}
                      setDropdownSelections={setDropdownSelections}
                      initialDropdownSelections={initialDropdownSelections}
                      setInitialDropdownSelections={setInitialDropdownSelections}
                      lastCurrentValueRef={lastCurrentValueRef}
                      dropdownRefs={dropdownRefs}
                    />
                  );
                }
                
                return (
                  <button
                    key={idx}
                    children={action.text}
                    className="action-button "
                    onClick={action.action}
                    style={{
                      backgroundImage: !action.text && action.image ? `url('${__dirname}${action.image}')` : undefined,
                      backgroundSize: '20px',
                      ...action.style,
                    }}
                  />
                );
              })}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ChartHead;
